import { useCallback, useState } from 'react';

import type { CalendarSlotMenu } from '@pages/Calendar/data';

// Меню шага сетки держится на уровне страницы журнала, а не колонки
// (issue/11214): клик по шагу в любой колонке заменяет открытое меню, второе
// рядом не появляется.
export const useCalendarSlotMenu = () => {
  const [slotMenu, setSlotMenu] = useState<CalendarSlotMenu | null>(null);

  const openSlotMenuHandler = useCallback((nextSlotMenu: CalendarSlotMenu) => {
    setSlotMenu(nextSlotMenu);
  }, []);

  const closeSlotMenuHandler = useCallback(() => {
    setSlotMenu(null);
  }, []);

  return {
    slotMenu,
    openSlotMenuHandler,
    closeSlotMenuHandler,
  };
};
